import styled from "styled-components";
import { Colors } from "../../styles/colors";

export const ContainerICP = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100vh;
	background-color: ${Colors?.primary_blue_k_main};
`;

export const FooterICP = styled.div<{ bgColor?: string }>`
	display: flex;
	width: 100%;
	flex-direction: column;
	justify-content: center;
	bottom: 0px;
	margin-top: 73px;
	background-color: ${({ bgColor }) => (bgColor ? bgColor : Colors?.white)};
`;
export const ContainerWelcomeComponent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100vh;
`;
export const ContainerQuestionsComponent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100vh;
`;
export const Content = styled.div`
	display: flex;
	width: 30%;
	align-self: center;
	flex-direction: column;
	position: relative;
`;
export const HeaderICP = styled.div`
	display: flex;
	width: 50%;
	padding-top: 20px;
	flex-direction: row;
	margin-top: 82px;
	position: relative;
`;
export const ContainerProgress = styled.div`
	display: flex;
	width: 50%;
	flex-direction: column;
	margin-top: 24px;
	margin-bottom: 24px;
`;
export const Progress = styled.div`
	width: 100%;
	height: 12px;
	border-radius: 12px;
	margin-top: 5px;
	background-color: ${Colors?.neutral_grey_k_10};
`;
const containerWidth = 50;
export const BackgroundProgress = styled.div<{
	width: number;
	questionsSize: number;
}>`
	width: ${({ width, questionsSize }) =>
		(containerWidth / questionsSize) * width}%;
	height: 12px;
	background-color: ${Colors?.secondary_green_k_main};
	border-radius: 12px;
	position: absolute;
`;
export const ContainerQuestionnarie = styled.div`
	display: flex;
	width: 50%;
	height: 58vh;
	flex-direction: column;
	overflow-y: auto;
`;
export const ContainerButtons = styled.div`
	display: flex;
	width: 50%;
	justify-content: center;
`;
export const Asterisco = styled.span`
	display: "inline";
	font-family: "NotoSans-Regular";
	font-size: 18px;
	color: ${Colors.tertirary_red_2_dark};
`;
